export default __webpack_public_path__ + "static/creative_follow_bg_mobile-84d1170522aed88687a796e9ee6a92c7.svg";